require('./contractEasyLoanTypeC.scss');

const PropTypes = require('prop-types');
//@vendor
const React = require('react');
const { withRouter } = require("react-router-dom");
//@commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { LoadingSection } = require('commonsComponents/loadingSection');
//@core
const { FormattedText } = require('core/i18n').i18n;
//@components
const ContractEasyLoanApprovedTypeCStep1 = require('./contractEasyLoanApprovedTypeCStep1/contractEasyLoanApprovedTypeCStep1');
const ContractEasyLoanApprovedTypeCStep2 = require('./contractEasyLoanApprovedTypeCStep2/contractEasyLoanApprovedTypeCStep2');
//@constants
const { FIRST_STEP, DOCUMENTS_PRINTED_AND_SIGNED } = require('constants/index');
const {
    catalogue,
    analyticsId,
    recordEasyLoanCApprovedWizardPrevious
} = require("./analytics/contractEasyLoanApprovedTypeC.tracking");

//@utilities
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const { NOT_ALLOWED_NEW_PREAPPROVAL_LOAN_FLOW_COUNTRIES } = require('constants/flagBasedFeatures');

class ContractEasyLoanApprovedTypeC extends React.Component {
    constructor(props) {
        super(props);

        this.onCancel = this.onCancel.bind(this);
        this.onFinalButtonDisabled = this.onFinalButtonDisabled.bind(this);

    }

    onCancel() {
        this.props.history.push('/myprofile/loans-mortgages');
    }

    builDisclaimerText(visibleStep) {
        const showSuperscriptInfo = visibleStep !== FIRST_STEP;
        if (showSuperscriptInfo) {
            return (
                <div className="contract-easy-loan-typec__superscript-info">
                    <FormattedText
                        value="contractEasyLoanTypeC-disclaimertext"
                    />
                </div>
            )
        }
    }

    onFinalButtonDisabled () {
        const { immPrinter, immContractEasyLoanInit }= this.props;

        const { YES } = DOCUMENTS_PRINTED_AND_SIGNED;

        const isOffice = __CONTACT_CENTER__ && isPrintOfficeMode();
        const isWeb = !__CONTACT_CENTER__ && !isPrintOfficeMode();

        const documentsPrintedAndSigned = immPrinter.get("documentsPrintedAndSigned");
        const isDocumentPrinted = immPrinter.get("isDocumentPrinted");


        if (isOffice) {
            return !isDocumentPrinted && documentsPrintedAndSigned === YES || documentsPrintedAndSigned !== YES
        }

        if (isWeb) {
            const documents = immContractEasyLoanInit.get('fileEasyLoanPolicyDocument');
            const isLoading = immContractEasyLoanInit.get('isFetchingPolicyDocuments');

            return !documents || isLoading
        }
    }

    render() {
        const {
            downloadPreContractDocument,
            getInstallment,
            immAccounts,
            immContractEasyLoanTypeC,
            immContractEasyLoanInit,
            immContractEasyLoan,
            immProfile,
            onDownloadDocument,
            onFinish,
            onPrintDocument,
            preContractualMail,
            requestMinInstallmentQuantity,
            requestProfile,
            resetPrecontractualMail,
            sendMail,
            setLoanAmount,
            setLoanTerm,
            setPurpose,
            setVisibleStep,
            setWillCancel,
            toggleAgreeCheckbox,
            sendEasyLoanSimpleEmail,
            setInitApiFlag,
            toggleINEAgreeCheckbox,
            onAgreeReset,
            immFlagBasedFeatures,
            officePrintReset,
            resetMailSent,
            setSelectedAccount,
            downloadINEDocument,
            setPaymentDay,
            downloanEasyLoanContractDocument,
            getHiringDocuments,
            getINEDocument,
            getEasyLoanPolicyDocument,
            setOfficeStep,
            validateStepLoansAndMorgages,
            getLoanContractDocuments,
            getBlockedAccounts,
            toggleTypecIneAgreeCheckbox,
            sendEasyLoanSimpleEmailApproved,
            checkReadDocument,
            immPrinter,
            setDocumentPrinted,
            showPrintedAndSignedStatusRequired,
            cleanErrorMessage,
        } = this.props;

        let immSteps = immContractEasyLoanTypeC.get('twoSteps');
        const stepsAmount = immSteps.size;
        const visibleStep = immContractEasyLoanTypeC.get('visibleStep');
        const disclaimerText = this.builDisclaimerText(visibleStep);
        immSteps = immSteps.map((step, index) => {
            if (index < visibleStep) {
                return step.set('valid', true);
            }
            return step;
        });
        const isFetchingStepOne = immContractEasyLoanTypeC.get('isFetchingInstallment') || immContractEasyLoanTypeC.get('isFetchingMinInstallmentQuantity') || immContractEasyLoanTypeC.get('isFetching');
        const immUpload = immContractEasyLoanTypeC.get("upload");
        const maxAmountError = immContractEasyLoanTypeC.get('maxAmountError');

        const isFetchingStepThree =
            immUpload.get("isFetching") ||
            immUpload.get("isFetchingDocumentsConfirm") ||
            immUpload.get("isLoadingFiles");
        const actions = {
            cancel: this.onCancel,
            finish: onFinish,
            resetStep: () => {
                (__CONTACT_CENTER__ && !isPrintOfficeMode() && immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PREAPPROVAL_LOAN_FLOW_COUNTRIES) && !immContractEasyLoanTypeC.get('isEasyLoanEmailSent')) ?
                    setInitApiFlag(false, immContractEasyLoanTypeC.get('mailAPIFlag'), immContractEasyLoanTypeC.get('checkboxFlag'), false) :
                    setInitApiFlag(false, false, true, false)
            },
            setVisibleStep,
            setWillCancel,
            validateStep: validateStepLoansAndMorgages,
            previousClick: recordEasyLoanCApprovedWizardPrevious
        };

        let stepOne = <LoadingSection />;
        if (immContractEasyLoanTypeC.get('stepReady')) {
            stepOne = (

                <ContractEasyLoanApprovedTypeCStep1
                    setPurpose={setPurpose}
                    getInstallment={getInstallment}
                    immContractEasyLoanTypeC={immContractEasyLoanTypeC}
                    setLoanAmount={setLoanAmount}
                    setLoanTerm={setLoanTerm}
                    downloadPreContractDocument={downloadPreContractDocument}
                    requestMinInstallmentQuantity={requestMinInstallmentQuantity}
                    showTooltip
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    setInitApiFlag={setInitApiFlag}
                    toggleINEAgreeCheckbox={toggleINEAgreeCheckbox}
                    onAgreeReset={onAgreeReset}
                    officePrintReset={officePrintReset}
                    resetMailSent={resetMailSent}
                    immAccounts={immAccounts}
                    setSelectedAccount={setSelectedAccount}
                    setPaymentDay={setPaymentDay}
                    getBlockedAccounts={getBlockedAccounts}

                />
            );
        }

        const tealiumData = [
            catalogue[analyticsId.CONTRACT_EASY_LOAN_STEP_1_VIEW](),
            catalogue[analyticsId.CONTRACT_EASY_LOAN_STEP_2_VIEW]({
                data: immContractEasyLoanTypeC.get("minTae"),
            }),
        ];
        const tealiumEvents = [
            catalogue[analyticsId.CONTRACT_EASY_LOAN_STEP_1_SUCCESS](),
        ];

        return (
            <React.Fragment>
                <Wizard
                    actions={actions}
                    immSteps={immSteps}
                    stepsAmount={stepsAmount}
                    visibleStep={visibleStep}
                    wizardClass="contract-easy-loan__wizard"
                    tealium={tealiumData[visibleStep - 1]}
                    tealiumForCancel={{
                        categoriaEvento: "proc-contratacion-prestamo-nomina",
                        accionEvento: "clickLink",
                        etiquetaEvento: "cancel"
                    }}
                    tealiumEvents={{
                        next: tealiumEvents[visibleStep - 1],
                        finish: catalogue[analyticsId.CONTRACT_EASY_LOAN_CONTRACT_BUTTON]()
                    }}
                    isTaggingSecondVersion
                >
                    <WizardStep
                        nextButton
                        cancelButton
                        position="first"
                        isLoading={isFetchingStepOne}
                        nextButtonDisabled={maxAmountError || !immContractEasyLoanTypeC.get('selectedAccount')}
                    >
                        {stepOne}
                    </WizardStep>
                    <WizardStep
                        officeSignature={isPrintOfficeMode()}
                        cancelButton
                        finishButton
                        finalButtonDisabled={this.onFinalButtonDisabled()}
                        immFinalButton="contractEasyLoanStepThree-callToActionButton"
                        isLoading={isFetchingStepThree}
                        addLoadingBehaviour
                        position="last"
                        previousButton
                    >
                        <ContractEasyLoanApprovedTypeCStep2
                            downloadINEDocument={downloadINEDocument}
                            downloanEasyLoanContractDocument={downloanEasyLoanContractDocument}
                            getHiringDocuments={getHiringDocuments}
                            immAccounts={immAccounts}
                            immContractEasyLoanTypeC={immContractEasyLoanTypeC}
                            immContractEasyLoanInit={immContractEasyLoanInit}
                            immContractEasyLoan={immContractEasyLoan}
                            immProfile={immProfile}
                            onDownloadDocument={onDownloadDocument}
                            onPrintDocument={onPrintDocument}
                            preContractualMail={preContractualMail}
                            requestProfile={requestProfile}
                            resetPrecontractualMail={resetPrecontractualMail}
                            sendMail={sendMail}
                            immFlagBasedFeatures={immFlagBasedFeatures}
                            getINEDocument={getINEDocument}
                            getEasyLoanPolicyDocument={getEasyLoanPolicyDocument}
                            toggleAgreeCheckbox={toggleAgreeCheckbox}
                            setOfficeStep={setOfficeStep}
                            getLoanContractDocuments={getLoanContractDocuments}
                            sendEasyLoanSimpleEmail={sendEasyLoanSimpleEmail}
                            sendEasyLoanSimpleEmailApproved={sendEasyLoanSimpleEmailApproved}
                            toggleTypecIneAgreeCheckbox={toggleTypecIneAgreeCheckbox}
                            checkReadDocument={checkReadDocument}
                            immPrinter={immPrinter}
                            setDocumentPrinted={setDocumentPrinted}
                            showPrintedAndSignedStatusRequired={showPrintedAndSignedStatusRequired}
                            cleanErrorMessage={cleanErrorMessage}
                        />
                    </WizardStep>

                </Wizard>
                {disclaimerText}
            </React.Fragment>
        );
    }
}

ContractEasyLoanApprovedTypeC.propTypes = {
    downloadINEDocument: PropTypes.func.isRequired,
    downloadPreContractDocument: PropTypes.func.isRequired,
    downloanEasyLoanContractDocument: PropTypes.func.isRequired,
    getAsnefValidation: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    getInstallment: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immContractEasyLoanTypeC: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    onDownloadDocument: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    requestMinInstallmentQuantity: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetStep: PropTypes.func.isRequired,
    sendMail: PropTypes.func.isRequired,
    setImportMaxMin: PropTypes.func.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setLoanTerm: PropTypes.func.isRequired,
    setPaymentDay: PropTypes.func.isRequired,
    setPurpose: PropTypes.func.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    toggleAgreeCheckbox: PropTypes.func.isRequired,
    toggleTypecIneAgreeCheckbox: PropTypes.func.isRequired,
    validateStepLoansAndMorgages: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    setLaborDetails: PropTypes.object.isRequired,
    formHandlers: PropTypes.object.isRequired,
    loadFileInUpload: PropTypes.object.isRequired,
    clearErrorsFile: PropTypes.object.isRequired,
    removeUploadedFile: PropTypes.object.isRequired,
    resetUploadConfig: PropTypes.object.isRequired,
    handlerEditFileName: PropTypes.object.isRequired,
    loadFilesEasyLoan: PropTypes.object.isRequired,
    docsUploaded: PropTypes.object.isRequired,
    printIneDocumentStep2: PropTypes.func.isRequired,
    sendEasyLoanSimpleEmail: PropTypes.func.isRequired,
    immPrinter: PropTypes.object.isRequired,
};

module.exports = withRouter(ContractEasyLoanApprovedTypeC);
